import { render, staticRenderFns } from "./InvestismentDetail.vue?vue&type=template&id=0db5f475&scoped=true"
import script from "./InvestismentDetail.vue?vue&type=script&lang=js"
export * from "./InvestismentDetail.vue?vue&type=script&lang=js"
import style0 from "./InvestismentDetail.vue?vue&type=style&index=0&id=0db5f475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db5f475",
  null
  
)

export default component.exports